import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { useSubdomain } from 'hooks/useSubdomain';
import { Spinfinity } from 'components';

import styles from './AuthLayout.module.css';

const AuthLayout = () => {
  const { isLoaded } = useSubdomain();

  if (!isLoaded) return null;
  return (
    <div>
      <div className={styles.authAppWrapper}>
        <div className={styles.contentWrapper}>
          <div className={styles.authWrapper}>
            <div className={styles.authWrapperInner}>
              <Suspense fallback={<Spinfinity />}>
                <Outlet />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AuthLayout;
